export const USER_REGION = 'userRegion';

export const USER_REGION_COOKIE_EXPIRATION_YEARS = 1;
